
import React from 'react';

interface ProtectedRouteProps {
  session: any;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ session, children }) => {
  if (!session) {
    return null; // App.tsx handles the redirection to Login
  }
  return <>{children}</>;
};

export default ProtectedRoute;
